import styled from 'styled-components'

import ModalBase from 'LuxKit/Modal/ModalBase'
import FormatCurrency from 'components/Common/FormatCurrency'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { getBaseTierOfferWithJoiningFee } from 'selectors/luxPlusSelectors'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

import LuxPlusFreePreviewUnlockedModalContent from './LuxPlusFreePreviewUnlockedModalContent'

// The branded card carries its own gradient, radius and shadow, so the modal sheet behind it is
// made invisible and just handles sizing/positioning within the portal.
const TransparentModal = styled(ModalBase)`
  && {
    background: transparent;
    box-shadow: none;
  }
`

/**
 * The connected "you've unlocked a free preview" modal, shown once a customer is enrolled into the
 * LuxPlus+ Free Preview (see useShowLuxPlusFreePreviewUnlockedModal). Replaces the old success
 * snackbar. Figma UX-4738.
 */
function LuxPlusFreePreviewUnlockedModal() {
  const modalContext = useModalElementContext()
  const standardOffer = useAppSelector(getBaseTierOfferWithJoiningFee)

  const onClose = () => modalContext?.resolve()

  return (
    <TransparentModal size="S" dismissible>
      <LuxPlusFreePreviewUnlockedModalContent
        membershipFee={<FormatCurrency format="roundedDollar" value={standardOffer?.price ?? 0} />}
        onClose={onClose}
        learnMoreTo={`/${LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE}`}
      />
    </TransparentModal>
  )
}

export default LuxPlusFreePreviewUnlockedModal
